import { useEffect, useState } from "react";
import { NavLink } from "../../lib/i18n";
import { Home, Store, Calculator, ShoppingBag, User } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { useCart } from "../../context/CartContext";
import { useSite } from "../../context/SiteContext";
import { NewsletterForm } from "./Footer";

export function MobileBar() {
  const { count, setOpen } = useCart();
  const cls = ({ isActive }) => `flex flex-col items-center gap-1 text-[10px] font-medium ${isActive ? "text-bois" : "text-pierre"}`;
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-5 border-t border-beige bg-ivoire/95 py-2.5 backdrop-blur-md xl:hidden" data-testid="mobile-bottom-bar">
      <NavLink to="/" end className={cls}><Home size={19} />Accueil</NavLink>
      <NavLink to="/boutique" className={cls}><Store size={19} />Boutique</NavLink>
      <NavLink to="/calculateur" className={cls}><Calculator size={19} />Calculer</NavLink>
      <button onClick={() => setOpen(true)} className="relative flex flex-col items-center gap-1 text-[10px] font-medium text-pierre" data-testid="mobile-cart-btn">
        <ShoppingBag size={19} />Panier{count > 0 && <span className="absolute right-[28%] -top-1 rounded-full bg-laiton px-1.5 text-[9px] font-bold text-ebene">{count}</span>}
      </button>
      <NavLink to="/compte" className={cls}><User size={19} />Compte</NavLink>
    </nav>
  );
}

export function NewsletterPopup() {
  const { marketing } = useSite();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!marketing?.popup?.enabled || localStorage.getItem("mb_popup")) return;
    const t = setTimeout(() => setOpen(true), 25000);
    return () => clearTimeout(t);
  }, [marketing]);
  const close = (v) => { setOpen(v); if (!v) localStorage.setItem("mb_popup", "1"); };
  const p = marketing?.popup || {};
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-lg bg-ivoire p-10" data-testid="newsletter-popup">
        <p className="eyebrow">Lettre de saison</p>
        <DialogTitle className="font-serif text-3xl text-brun">{p.title}</DialogTitle>
        <p className="text-sm text-pierre">{p.text}</p>
        {p.code && <p className="text-sm">Code offert : <b className="text-bois">{p.code}</b></p>}
        <NewsletterForm dark={false} source="popup" />
      </DialogContent>
    </Dialog>
  );
}

export function CookieBanner() {
  const [show, setShow] = useState(() => !localStorage.getItem("mb_cookies"));
  if (!show) return null;
  const set = (v) => { localStorage.setItem("mb_cookies", v); setShow(false); };
  return (
    <div className="fixed bottom-20 left-4 right-24 z-40 max-w-sm rounded-lg border border-beige bg-ivoire p-4 sm:right-auto sm:p-5 shadow-[0_20px_50px_rgba(42,24,16,0.15)] xl:bottom-6" data-testid="cookie-banner">
      <p className="text-sm text-encre">Nous utilisons des cookies essentiels et, avec votre accord, des cookies de mesure d'audience.</p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => set("all")} className="btn-primary !py-2.5 !px-4" data-testid="cookie-accept-btn">Accepter</button>
        <button onClick={() => set("essential")} className="btn-ghost !py-2.5 !px-4" data-testid="cookie-refuse-btn">Essentiels uniquement</button>
      </div>
    </div>
  );
}
